import Card from '@mui/material/Card'
import styled from '@mui/material/styles/styled'

export const ServiceListCard = styled(Card, {
  name: 'ServiceListCard',
  slot: 'Root',
  skipSx: true,
})`
  border: solid 1px #ddd;
  border-radius: 4px;
`
